import { useDispatch, useSelector } from 'react-redux';
import { ERROR_PAGE_TYPES } from './constants/ErrorPageTypes';
import {
  actionSetErrorType,
  actionSetShouldShowErrorInPage,
} from '../store/Error/ErrorAction';
import { actionSetDraftReservation } from '../store/Reservations/ReservationsAction';
import {
  actionGetDateRangeAvailabilityFail,
  actionGetSpecificVenueAvailabilityFail,
} from '../store/Availability/AvailabilityAction';

export const useError = () => {
  const dispatch = useDispatch();
  const { draftReservation } = useSelector((state) => state.reservations);
  const { market } = useSelector((state) => state.markets);

  const throwError = (errorType) => {
    switch (errorType) {
      case 'ERROR_DETAILS_MODAL':
        dispatch(actionGetDateRangeAvailabilityFail());
        break;
      case 'ERROR_DETAILS_PAGE':
        dispatch(actionSetShouldShowErrorInPage(true));
        break;
      case 'ERROR_DETAILS_CARD':
        const venues = market.venues.items;
        dispatch(
          actionGetSpecificVenueAvailabilityFail(
            venues.map((venue) => venue.sevenRoomsVenueId)
          )
        );
        break;
      case ERROR_PAGE_TYPES.NO_AVAILABILITY.value:
        dispatch(
          actionSetDraftReservation({ ...draftReservation, isAvailable: false })
        );
        break;
      default:
        if (!Object.keys(ERROR_PAGE_TYPES).includes(errorType)) {
          throw new Error(`Invalid error type: ${errorType}`);
        }
        const error = ERROR_PAGE_TYPES[errorType];
        dispatch(actionSetErrorType(error.value));
        break;
    }
  };

  return { throwError };
};
